// extracted by mini-css-extract-plugin
export var cardIcon = "_a8-5";
export var cardIconUnframed = "_a8-9";
export var checkboxCard = "_a8-0";
export var checkboxCardSelected = "_a8-4";
export var disabled = "_a8-2";
export var interactive = "_a8-1";
export var outerBorder = "_a8-3";
export var spacerMedium = "_a8-8";
export var spacerSmall = "_a8-7";
export var spacerXsmall = "_a8-6";